import React from 'react'
import { toast } from "react-toastify";

export const addMachine = (machine) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    //make assync call
    const firestore = getFirestore();
    let autoID = firestore.collection("machines").doc().id;
    firestore
      .collection("machines")
      .doc(autoID)
      .set({
        ...machine,
        unitInfo: false,
        authorName: "Admin",
        id: autoID,
        createdAt: new Date(),
      })
      .then(() => {
        dispatch({
          type: "ADD_MACHINE",
          machine,
        });
        toast.success("Machine added successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000
        });
      })
      .catch((err) => {
        dispatch({
          type: "ADD_MACHINE_ERROR",
          err,
        });
      });
  };
};

export const updateMachine = (machine) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    //make assync call
    const firestore = getFirestore();
    firestore
      .collection("machines")
      .doc(machine.id)
      .update({
        ...machine,
        createdAt: new Date(),
      })
      .then(() => {
        dispatch({
          type: "UPDATE_MACHINE",
          machine,
        });
        toast.success("Machine Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000
        });
      })
      .catch((err) => {
        dispatch({
          type: "UPDATE_MACHINE_ERROR",
          err,
        });
      });
  };
};

export const updateMachineMoreInfo = (machine) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    //make assync call
    const firestore = getFirestore();
    firestore
      .collection("machines")
      .doc(machine.id)
      .update({
        ...machine,
        createdAt: new Date(),
      })
      .then(() => {
        dispatch({
          type: "UPDATE_MACHINE",
          machine,
        });
        toast.success("Machine Updated Successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000
        });
      })
      .catch((err) => {
        dispatch({
          type: "UPDATE_MACHINE_ERROR",
          err,
        });
        toast.error("Somethin went wrong", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000
        });
      });
  };
};


export const searchMachine = (UHANo, unit, userType) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    //make assync call
    console.log(UHANo, unit, userType);
    const firestore = getFirestore();
    if (userType == "admin") {
      firestore
        .collection("machines")
        .where("UHANo", "==", UHANo)
        .get()
        .then((querySnapshot) => {
          const data = querySnapshot.docs.map((doc) => doc.data());
          console.log(data); // array of cities objects
          if(data === undefined || data.length === 0 ){
            toast.error("No available machine for your UHA No", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000
            });
          }else{
            toast.success("Machine found", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000
            });
          }
          dispatch({
            type: "SEARCH_MACHINE",
            data,
          });
      
         
        })
        .catch((err) => {
          dispatch({
            type: "SEARCH_MACHINE_ERROR",
            err,
          });
        });
    } else {
      firestore
        .collection("machines")
        .where("UHANo", "==", UHANo)
        .where("unit", "==", unit)
        .get()
        .then((querySnapshot) => {
          const data = querySnapshot.docs.map((doc) => doc.data());
          console.log(data); // array of cities objects
          if(data === undefined || data.length === 0 ){
            toast.error("No available machine for your UHA No", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000
            });
          }else{
            toast.success("Machine found", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000
            });
          }
          dispatch({
            type: "SEARCH_MACHINE",
            data,
          });
        })
        .catch((err) => {
          dispatch({
            type: "SEARCH_MACHINE_ERROR",
            err,
          });
        });
    }
  };
};

export const addMachineMoreInfo = (machine) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    //make assync call
    const firestore = getFirestore();
    firestore
      .collection("machines")
      .doc(machine.id)
      .update({
        ...machine,
        createdAt: new Date(),
      })
      .then(() => {
        dispatch({
          type: "ADD_MACHINE_MORE_INFO",
          machine,
        });
        toast.success("Successfully Added", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000
        });
      })
      .catch((err) => {
        dispatch({
          type: "ADD_MACHINE_MORE_INFO_ERROR",
          err,
        });
        toast.success("Something went wrong!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000
        });
      });
  };
};

export const getAllMachines = (unit,userType) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    //make assync call
    // console.log(UHANo, unit, userType);
    const firestore = getFirestore();
    if (userType == "admin" || userType == "viewer") {
      firestore
        .collection("machines")
        .orderBy('createdAt', 'desc')
        .get()
        .then((querySnapshot) => {
          const data = querySnapshot.docs.map((doc) => doc.data());
          console.log(data); // array of cities objects
          if(data === undefined || data.length === 0 ){
            toast.error("No available machine for your UHA No", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000
            });
          }
          dispatch({
            type: "GET_ALL_MACHINES",
            data,
          });
      
         
        })
        .catch((err) => {
          dispatch({
            type: "GET_ALL_MACHINES_ERROR",
            err,
          });
        });
    } else {
      firestore
        .collection("machines")
        .where("unit", "==", unit)
        .get()
        .then((querySnapshot) => {
          const data = querySnapshot.docs.map((doc) => doc.data());
          console.log(data); // array of cities objects
          dispatch({
            type: "GET_ALL_MACHINES",
            data,
          });
        })
        .catch((err) => {
          dispatch({
            type: "GET_ALL_MACHINES_ERROR",
            err,
          });
        });
    }
  };
};


export const resetSearch = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({
      type: "RESET_SEARCH",
    });
  };
};


export const resetAllMachines = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({
      type: "RESET_ALL_MACHINES",
    });
  };
};

